import { FcPermissions } from '@fc-core';
import { NavigationItem } from '@fc-core/navbar/navigation/navigation-item';
import { Permission } from '@fc-core';

export const defaultNavigation: NavigationItem[] = [
  {
    name: 'Dashboard',
    icon: 'icon-home-outline',
    iconActive: 'icon-home-bold',
    link: '/dashboard',
  },
  {
    name: 'Map',
    icon: 'icon-map-outline',
    iconActive: 'icon-map-bold',
    link: '/map',
    permissionKey: FcPermissions.mapFeature,
  },
  {
    name: 'Vehicles',
    icon: 'icon-vehicles-outline',
    iconActive: 'icon-vehicles-bold',
    open: false,
    inner: [
      {
        name: 'Vehicle List',
        link: '/vehicles',
      },
      {
        name: 'Cameras',
        link: '/cameras',
        featureKey: 'cameras_overview',
        permissionKey: FcPermissions.dvrViewLiveVideo,
      },
      {
        name: 'Live Share',
        link: '/shared',
      },
    ],
  },
  {
    name: 'Locations',
    icon: 'icon-location-outline',
    iconActive: 'icon-location-bold',
    link: '/locations',
    featureKey: 'locations',
  },
  {
    name: 'Employees',
    icon: 'icon-group-outline',
    iconActive: 'icon-group-bold',
    open: false,
    inner: [
      {
        name: 'Employee List',
        link: '/users',
      },
      {
        name: 'Time Management',
        link: '/time-management',
      },
    ],
  },
  {
    name: 'Assets',
    icon: 'icon-tool',
    iconActive: 'icon-tool-bold',
    link: '/fleet-assets',
    featureKey: 'assets',
  },
  {
    name: 'Dispatch',
    icon: 'icon-tasks-outline',
    iconActive: 'icon-tasks-bold',
    beta: true,
    open: false,
    inner: [
      {
        name: 'Tasks',
        link: '/tasks',
        featureKey: 'project_tasks_management',
      },
      {
        name: 'Projects',
        link: '/projects',
        featureKey: 'projects',
      },
    ],
  },
  {
    name: 'Chats',
    icon: 'icon-chats-outline',
    iconActive: 'icon-chats-bold',
    link: '/chats',
    featureKey: 'chats',
    beta: true,
  },
  {
    name: 'CRM',
    icon: 'icon-crm-outline',
    iconActive: 'icon-crm-bold',
    link: '/crm',
    featureKey: 'crm',
  },
  {
    name: 'Forms',
    icon: 'icon-inspections-outline',
    iconActive: 'icon-inspections-bold',
    open: false,
    featureKey: 'forms',
    inner: [
      {
        name: 'Forms List',
        link: '/forms/forms-list',
      },
      {
        name: 'Submissions',
        link: '/forms/submissions',
      },
    ],
  },
  {
    name: 'Reports',
    icon: 'icon-reports-outline',
    iconActive: 'icon-reports-bold',
    link: '/reports',
    featureKey: 'reports',
  },
  {
    name: 'Documents',
    icon: 'icon-document-outline',
    iconActive: 'icon-document-bold',
    link: '/documents',
    featureKey: 'drive_documents',
  },
  {
    name: 'Events',
    icon: 'icon-events-outline',
    iconActive: 'icon-events-bold',
    link: '/events',
    beta: true,
    featureKey: 'events',
  },
];

export function filterNavigation(
  navigation: NavigationItem[],
  permissions: Permission[],
  features: string[],
  newsToShow: number,
  messages: number,
): NavigationItem[] {
  return navigation
    .map((navItem) => {
      if (!navItem?.inner) return navItem;

      return {
        ...navItem,
        inner: filterNavigation(
          navItem.inner,
          permissions,
          features,
          newsToShow,
          messages,
        ),
      };
    })
    .filter((navItem) => {
      if (navItem?.featureKey && !features?.includes(navItem.featureKey))
        return false;
      if (
        navItem?.permissionKey &&
        !permissions?.some((p) => p.codename === navItem.permissionKey)
      )
        return false;
      if (navItem?.inner) return navItem.inner.length > 0;

      return true;
    })
    .map((navItem) =>
      setNavigationNotifications(navItem, newsToShow, messages),
    );
}

export function setNavigationNotifications(
  navigationItem: NavigationItem,
  newsToShow: number,
  messages: number,
): NavigationItem {
  if (navigationItem.name === 'News') navigationItem.notification = newsToShow;
  if (navigationItem.name === 'Chats') navigationItem.notification = messages;
  return navigationItem;
}
